<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <card>
          <template slot="header">
            <h4 class="card-title">{{shopData.channelName}}<span v-show="shopData.isNewOa">（已更新）</span></h4>
          </template>
          <div>
            <form method="get" action="/" class="form-horizontal">
              
              <div class="row">
                <div class="col-sm-6">
                  <div class="row">
                    <label class="col-sm-4 col-form-label">LINE Channel ID</label>
                    <div class="col-sm-8">
                      <fg-input placeholder="Email" v-model="shopData.lineChannelId"></fg-input>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="row">
                    <label class="col-sm-4 col-form-label">LINE Channel Secret</label>
                    <div class="col-sm-8">
                      <fg-input placeholder="Phone" v-model="shopData.lineChannelSecret"></fg-input>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-6">
                  <div class="row">
                    <label class="col-sm-4 col-form-label">LINE Channel Token</label>
                    <div class="col-sm-8">
                      <fg-input placeholder="Invoice" v-model="shopData.lineChannelToken"></fg-input>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="row">
                    <label class="col-sm-4 col-form-label">LINE Basic ID</label>
                    <div class="col-sm-8">
                      <fg-input placeholder="Email" v-model="shopData.lineBasicId"></fg-input>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-6">
                  <div class="row">
                    <label class="col-sm-4 col-form-label">LINE Add Friend Url</label>
                    <div class="col-sm-8">
                      <fg-input placeholder="Phone" v-model="shopData.lineAddFriendUrl"></fg-input>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="row">
                    <label class="col-sm-4 col-form-label">LINE Channel Image Url</label>
                    <div class="col-sm-8">
                      <fg-input placeholder="Invoice" v-model="shopData.lineChannelImageUrl"></fg-input>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-6">
                  <div class="row">
                    <label class="col-sm-4 col-form-label">LINE Provider ID</label>
                    <div class="col-sm-8">
                      <fg-input placeholder="Email" v-model="shopData.lineProviderId"></fg-input>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="row">
                    <label class="col-sm-4 col-form-label">Menu LIFF ID</label>
                    <div class="col-sm-8">
                      <fg-input placeholder="Email" v-model="shopData.menuLiffId"></fg-input>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-6">
                  <div class="row">
                    <label class="col-sm-4 col-form-label">Eat-in Menu LIFF ID</label>
                    <div class="col-sm-8">
                      <fg-input placeholder="Phone" v-model="shopData.eatInLiffId"></fg-input>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="row">
                    <label class="col-sm-4 col-form-label">Order LIFF ID</label>
                    <div class="col-sm-8">
                      <fg-input placeholder="Invoice" v-model="shopData.orderLiffId"></fg-input>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="row">
                    <label class="col-sm-4 col-form-label">Pick-Up LIFF ID</label>
                    <div class="col-sm-8">
                      <fg-input placeholder="Invoice" v-model="shopData.pickUpLiffId"></fg-input>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-sm-6">
                <div class="row">
                  <label class="col-sm-4 col-form-label">Richmenu</label>
                  <el-select
                    class="select-primary"
                    size="large"
                    placeholder="Single Select"
                    v-model="selectedRichmenu"
                    @change="selectChange()"
                  >
                    <el-option
                      v-for="option in richmenus"
                      class="select-primary"
                      :value="option.id"
                      :label="option.name"
                      :key="option.id"
                    ></el-option>
                  </el-select>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-10">
                    <b>Webhook URL:</b>
                    {{webhookUrl}}
                  <input type="hidden" id="webhook-url" :value="webhookUrl">
                  <button v-on:click.prevent="copy('webhook-url')">複製</button>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-10">
                    <b>Info URL:</b>
                    {{managerInfo.infoUrl}}
                  <input type="hidden" id="info-url" :value="managerInfo.infoUrl">
                  <button v-on:click.prevent="copy('info-url')">複製</button>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-10">
                    <b>Order URL:</b>
                    {{managerInfo.orderUrl}}
                  <input type="hidden" id="order-url" :value="managerInfo.orderUrl">
                  <button v-on:click.prevent="copy('order-url')">複製</button>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-10">
                    <b>Menu URL:</b>
                    {{managerInfo.menuUrl}}
                  <input type="hidden" id="menu-url" :value="managerInfo.menuUrl">
                  <button v-on:click.prevent="copy('menu-url')">複製</button>
                </div>
              </div>

            </form>
            <div class="row justify-content-md-center">
              <div class="col-md-3">
                <n-button native-type="button" type="gray" @click.native="home()">
                  回商店列表
                </n-button>
              </div>
              <div class="col-md-3">
                <n-button native-type="button" type="primary" @click.native="edit()">
                  更新商店
                </n-button>
              </div>
              <div class="col-md-3">
                <n-button native-type="button" type="success" @click.native="save()">
                  儲存當前OA設定
                </n-button>
              </div>
              <div class="col-md-3">
                <n-button native-type="button" type="info" @click.native="del()">
                  清除圖文選單
                </n-button>
              </div>
            </div>
          </div>
        </card>
        <!-- end card -->
      </div>
    </div>
  </div>
</template>

<script>
import {
  Checkbox,
  Radio,
  Switch,
  FormGroupInput as FgInput
} from "src/components/index";
import { fetchShopEdit, fetchManagerInfo } from "src/javascripts/generalPages/fetchData";
import { updateLineOa, delRichmenu, saveOaSettings } from "src/javascripts/generalPages/postData";
import { shopEdit, shopStatus } from "src/javascripts/generalPages/updateData";
import swal from 'sweetalert2';

import axios from 'axios';

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

var type;
var bType;
var siAccountId;
var id;
export default {
  components: {
    Checkbox,
    Radio,
    FgInput,
    [Switch.name]: Switch,
    quillEditor
  },
  beforeRouteEnter(to, from, next) {
    console.log("this.$route: ", to);
    id = to.params.id;
    type = to.params.type;
    bType = to.query.type;
    siAccountId = to.query.siAccountId;
    fetchShopEdit(id, type)
      .then(res => {
        console.log("res: ", res);
        next(vm => vm.setData(res.data));
      })
      .catch(err => {
        console.log("err: ", err);
      });
  },
  created: function() {
    fetchManagerInfo(siAccountId, type, bType, id)
    .then(res => {
      console.log("fetchManagerInfo: ", res)
      if(res.data.length > 0) {
        this.managerInfo = Object.assign({}, {...res.data[0]});
        if(this.managerInfo.webhookUrlDomain == 'line-aptg.wifiotg.com') {
          this.managerInfo.webhookUrlDomain = 'aptg-line.wifiotg.com';
        }
        if(this.managerInfo.webhookUrlDomain == 'line-lifeplus.wifiotg.com') {
          this.managerInfo.webhookUrlDomain = 'lifeplus-line.wifiotg.com';
        }
        this.webhookUrl = `https://${this.managerInfo.webhookUrlDomain}/line/general/${this.shopData.lineChannelId}/code/${this.shopData.randomCode}`;
      };
    })
    .catch(err => {
      console.log("fetchManagerInfo err: ", err.stack)
    })
  },
  data() {
    return {
      shopData: "",
      test: "",
      selectedRichmenu: 0,
      richmenus: [
        {
          id: 0,
          value: '',
          name: '請選擇'
        }, {
          id: 1,
          value: 'jessica_catering-basic-independent',
          name: '基本選單'
        }, {
          id: 2,
          value: 'jessica_catering-reviewPlusFB-independent',
          name: '行銷選單'
        }, {
          id: 3,
          value: 'lifeplus_catering-basic-independent',
          name: 'lifeplus基本選單'
        }, {
          id: 4,
          value: 'lifeplus_catering-reviewPlusFB-independent',
          name: 'lifeplus行銷選單'
        }, {
          id: 5,
          value: 'aptg_catering-basic-independent',
          name: 'aptg基本選單'
        }, {
          id: 6,
          value: 'rocio_retail-basic-independent',
          name: '零售基本選單'
        }, {
          id: 7,
          value: 'rocio_catering-17lifePickUp',
          name: '寄杯選單'
        }
      ],
      webhookUrl: "",
      managerInfo: {}
    };
  },
  methods: {
    setData: function(data) {
      console.log(process.env.VUE_APP_SI);
      if(process.env.VUE_APP_SI == 'lifeplus') {
        this.richmenus = [
        {
          id: 0,
          value: '',
          name: '請選擇'
        }, {
          id: 1,
          value: 'lifeplus_catering-basic-independent',
          name: 'lifeplus基本選單'
        }, {
          id: 2,
          value: 'lifeplus_catering-reviewPlusFB-independent',
          name: 'lifeplus行銷選單'
        }
      ]
      } else if(process.env.VUE_APP_SI == 'aptg') {
        this.richmenus = [
        {
          id: 0,
          value: '',
          name: '請選擇'
        }, {
          id: 1,
          value: 'aptg_catering-basic-independent',
          name: 'aptg基本選單'
        }
      ]
      }
      this.shopData = data;
      this.shopData.type = 'catering';
      console.log("this.shopData: ", this.shopData);
    },
    edit: function() {
      if(this.selectedRichmenu == 0) {
        this.$message({
          type: "error",
          message: "請選擇選單樣式"
        });
      } else {
        this.shopData.styleAndFileName = this.richmenus[this.selectedRichmenu].value;
        console.log(this.shopData);
        this.shopData.type = 'catering';
        updateLineOa(this.shopData, type)
        .then(res => {
          console.log(res);
          alert("更新成功");
          window.location.reload();
        })
        .catch(err => {
          this.$message({
            type: "error",
            message: "更新失敗，請檢查所有參數"
          });
          console.log(err);
        });
      }
      
    },
    selectChange: function() {
      console.log(this.selectedRichmenu)
    },
    home: function() {
      window.history.back();
    },
    copy(id) {
      let textToCopy = document.querySelector("#" + id);
      textToCopy.setAttribute('type', 'text');
      textToCopy.select();
      var successful = document.execCommand("copy");
      textToCopy.setAttribute('type', 'hidden');
      if(successful){
        this.$message({
          type: 'success', message: `已複製`
        });
      } else {
        this.$message({
          type: 'warning', message: `錯誤`
        });
      }
    },
    del() {
        delRichmenu(this.shopData, type)
        .then(res => {
          console.log(res);
          alert("選單刪除成功");
          // window.location.reload();
        })
        .catch(err => {
          this.$message({
            type: "error",
            message: "更新失敗，請檢查所有參數"
          });
          console.log(err);
        });
    },
    save() {
      saveOaSettings(this.shopData)
      .then(res => {
        this.$message({
          type: 'success', message: `當前OA設定已儲存`
        });
      })
      .catch(err => {
        this.$message({
            type: "error",
            message: "更新失敗，請檢查所有參數"
          });
          console.log(err);
      });
    }
  }
};
</script>

<style>
  .ql-editor{
    height: 100px;
  }
</style>